import React, { Component } from 'react';
import { Modal, Checkbox, message } from 'antd';
import ExportUtil from '../../../../common/ExportUtil';
import API_URL from '../../../../common/url';

class ExportModal extends Component {
    state = {
        columns: [],
        visible: false,
    }

    show = () => {
        this.setState({
            visible: true,
            columns: [
                {
                    label: 'CRC服务', value: 'CRC服务', checked: false, child: [
                        {
                            label: 'FTE制报价', value: 'FTE制报价', checked: false, child: [
                                { label: 'CRC服务', value: 'CRC服务', checked: false },
                                { label: '其他CRC服务', value: '其他CRC服务', checked: false },
                                { label: '项目管理', value: '项目管理', checked: false },
                                { label: '遗传办服务', value: '遗传办服务', checked: false },
                                { label: '患者预筛服务', value: '患者预筛服务', checked: false },
                                { label: '第三方代垫费', value: '第三方代垫费', checked: false },
                            ]
                        }
                    ]
                }
            ]
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    getChecked = (data, res) => {
        data.forEach(item => {
            const { value, checked, child } = item;
            if (child) {
                this.getChecked(child, res);
            } else if (checked) {
                res[value] = checked;
            }
        });
    } 

    confirm = () => {
        const { columns } = this.state;

        const params = {};
        this.getChecked(columns, params);

        if (Object.keys(params).length === 0) {
            message.warning('请选择需要导出的报价模块');
            return;
        }

        const url = API_URL.user.exportOutputRate;
        ExportUtil.export({ ...params }, null, url);
        this.hide();
    }

    handleCheckChange = (e, pos) => {
        const { columns } = this.state;

        // 取到选中项
        let posArr = pos.split('-');
        let item = columns;
        while(posArr.length) {
            let idx = posArr.shift();
            if (Array.isArray(item)) {
                item = item[idx];
            } else {
                item = item.child[idx];
            }
        }

        // 对选中项及以下选项设置
        this.toggleItemChecked(item, e.target.checked);

        this.setState({ columns });
    }

    toggleItemChecked = (item, checked) => {
        item.checked = checked;
        if (item.child) {
            item.child.forEach(i => this.toggleItemChecked(i, checked));
        }
    }

    /**
     * 获取导出项
     * @param {*} data checkbox选项列表
     * @param {*} pos 选项所处的层级位置；0-0-0
     */
    getContent = (data, pos) => {
        return (
            <div style={{ paddingLeft: pos ? 20 : 0, overflow: 'hidden' }}>
                {
                    data.map((column, index) => {
                        const { label, checked, child = [] } = column;
                        const newPos = pos ? `${pos}-${index}` : index + '';
                        const len = child.length;
                        return (
                            <div key={newPos} style={len === 0 ? {float: 'left', width: '33.33%', marginTop: 10} : {width: '100%', marginTop: 10}}>
                                <Checkbox
                                    checked={checked}
                                    onChange={(e) => this.handleCheckChange(e, newPos)}
                                >{label}</Checkbox>
                                {
                                    !!len && this.getContent(child, newPos)
                                }
                            </div>
                        )
                    })
                }
            </div>
        );
    }

    render() {
        const { visible, columns } = this.state;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                maskClosable={false}
                width="500px"
            >
                <div style={{ padding: '0px 10px 10px' }}>
                    <div style={{ padding: 10, background: '#f1f1f1' }}>请选择需要导出的报价模块</div>
                    {this.getContent(columns)}
                </div>
            </Modal>
        );
    }
}

export default ExportModal;


// WEBPACK FOOTER //
// ./src/components/quotation/list/Components/ExportModal.js